import { ReactElement } from 'react';
import { Link } from 'react-scroll';

import { Button } from '@mui/material';

import Image from '../../../../components/Image';
import Product from '../Product';

export default function SlotGames(): ReactElement {
  return (
    <Product
      label='Slot Games'
      hash='slots_product'
      color='info'
      image={
        <Image
          alt='Slot Games Image'
          thumbnailSrc='https://cdn.tain.com/demo/products/low-quality/slotgame.png'
          fullSrc='https://cdn.tain.com/demo/products/high-quality/slotgame.png'
        />
      }>
      <Link
        aria-label='Slot Games Product Link'
        to='casino_games'
        spy
        smooth
        offset={-99.19}
        style={{ position: 'relative' }}>
        <Button color='info' variant='contained'>
          Go To
        </Button>
      </Link>
    </Product>
  );
}
